<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'
import type { GatIconProps } from '../../gat-icon'
import { PopoverTrigger, type PopoverTriggerProps } from '../../ui/popover'

export interface DataTableCellPopoverTriggerProps {
  popoverTriggerProps?: PopoverTriggerProps
  class?: HTMLAttributes['class']
  iconProps?: GatIconProps & { position?: 'left' | 'right' }
  maxWidth?: number
}

const props = withDefaults(defineProps<DataTableCellPopoverTriggerProps>(), {
  popoverTriggerProps: () => ({ asChild: true }),
  maxWidth: 220,
  iconProps: () => ({ icon: 'ChevronsUpDown', position: 'right' })
})
</script>
<template>
  <PopoverTrigger v-bind="popoverTriggerProps" @click.stop>
    <div
      :class="
        cn(
          'hover:bg-background flex cursor-pointer items-center gap-2 rounded-md p-2 transition-shadow hover:shadow-sm',
          props.class
        )
      "
      :style="{ maxWidth: props.maxWidth + 'px' }"
    >
      <gat-icon
        v-if="props.iconProps?.position === 'left'"
        v-bind="props.iconProps"
        :class="cn('ml-auto size-3.5 shrink-0', props.iconProps.class)"
      />
      <slot />
      <gat-icon
        v-if="props.iconProps?.position === 'right'"
        v-bind="props.iconProps"
        :class="cn('ml-auto size-3.5 shrink-0', props.iconProps.class)"
      />
    </div>
  </PopoverTrigger>
</template>
